/** Default row counts for list tables (`AppDataTable`, Risks, RCM, Test Runs). */
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const;

export const DEFAULT_PAGE_SIZE: number = DEFAULT_PAGE_SIZE_OPTIONS[0];

const LIST_PAGE_SIZE_STORAGE_KEY = 'sox-list:page-size-v1';
const LEGACY_RISKS_PAGE_SIZE_STORAGE_KEY = 'sox-risks:page-size-v1';

function listPageSizeStorageKey(): string {
  if (typeof window === 'undefined') return LIST_PAGE_SIZE_STORAGE_KEY;
  const userId = window.localStorage.getItem('userId');
  return userId ? `${LIST_PAGE_SIZE_STORAGE_KEY}:${userId}` : LIST_PAGE_SIZE_STORAGE_KEY;
}

function legacyRisksPageSizeStorageKey(): string {
  if (typeof window === 'undefined') return LEGACY_RISKS_PAGE_SIZE_STORAGE_KEY;
  const userId = window.localStorage.getItem('userId');
  return userId
    ? `${LEGACY_RISKS_PAGE_SIZE_STORAGE_KEY}:${userId}`
    : LEGACY_RISKS_PAGE_SIZE_STORAGE_KEY;
}

/** Last rows-per-page (10/25/50/100) shared across list pages e.g. `/sox-risks`, `/sox-controls`. */
export function readStoredListPageSize(): number {
  if (typeof window === 'undefined') return DEFAULT_PAGE_SIZE;
  try {
    let raw = window.localStorage.getItem(listPageSizeStorageKey());
    if (raw == null || raw === '') {
      raw = window.localStorage.getItem(legacyRisksPageSizeStorageKey());
    }
    if (raw == null || raw === '') return DEFAULT_PAGE_SIZE;
    return normalizePageSize(Number(raw), DEFAULT_PAGE_SIZE_OPTIONS);
  } catch {
    return DEFAULT_PAGE_SIZE;
  }
}

export function writeStoredListPageSize(pageSize: number): void {
  if (typeof window === 'undefined') return;
  try {
    const normalized = normalizePageSize(pageSize, DEFAULT_PAGE_SIZE_OPTIONS);
    window.localStorage.setItem(listPageSizeStorageKey(), String(normalized));
  } catch {
    /* ignore quota / private mode */
  }
}

export function normalizePageSize(
  value: number,
  options: readonly number[] = DEFAULT_PAGE_SIZE_OPTIONS
): number {
  const n = Number(value);
  if (options.some((o) => o === n)) return n;
  return options[0] ?? DEFAULT_PAGE_SIZE;
}
